import React, { useEffect, useState } from "react";

import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography
} from "@mui/material";

import {
  ResponsiveContainer,
  LineChart,        // ⭐ CHANGED: LineChart added
  Line,             // ⭐ CHANGED
  CartesianGrid,    // ⭐ CHANGED
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  Legend
} from "recharts";

import api from "../../api/api";

export default function BillingOverview() {

  const [summary, setSummary] = useState({
    totalRevenue: 0,
    pendingInvoices: 0,
    totalClients: 0,
    totalProjects: 0
  });

  const [monthlyRevenue, setMonthlyRevenue] = useState([]);

  const [clientBilling, setClientBilling] = useState([]);

  useEffect(() => {
    loadBillingSummary();
    loadMonthlyRevenue();
    loadClientBilling();
  }, []);

  // ======================================================
  // LOAD BILLING SUMMARY
  // ======================================================

  const loadBillingSummary = async () => {

    try {

      const res = await api.get("/billing/summary");

      setSummary(res.data);

    } catch (err) {

      console.error("Billing summary error", err);

    }

  };

  // ======================================================
  // MONTHLY REVENUE
  // ======================================================

  const loadMonthlyRevenue = async () => {

    try {

      const res = await api.get("/billing/monthly-revenue");

      setMonthlyRevenue(res.data);

    } catch (err) {

      console.error("Monthly revenue error", err);

    }

  };

  // ======================================================
  // CLIENT BILLING
  // ======================================================

  const loadClientBilling = async () => {

    try {

      const res = await api.get("/billing/client-revenue");

      setClientBilling(res.data);

    } catch (err) {

      console.error("Client billing error", err);

    }

  };

  const COLORS = ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6"];

  return (

    <Box p={4}>

      {/* ========================================= */}
      {/* PAGE TITLE */}
      {/* ========================================= */}

      <Typography variant="h5" mb={3} fontWeight="bold">
        Billing Overview
      </Typography>

      {/* ========================================= */}
      {/* KPI CARDS */}
      {/* ========================================= */}

      <Grid container spacing={3} mb={4}>

        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>

              <Typography color="text.secondary">
                Total Revenue
              </Typography>

              <Typography variant="h5">
                ₹ {summary.totalRevenue}
              </Typography>

            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>

              <Typography color="text.secondary">
                Pending Invoices
              </Typography>

              <Typography variant="h5">
                {summary.pendingInvoices}
              </Typography>

            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>

              <Typography color="text.secondary">
                Clients
              </Typography>

              <Typography variant="h5">
                {summary.totalClients}
              </Typography>

            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>

              <Typography color="text.secondary">
                Billable Projects
              </Typography>

              <Typography variant="h5">
                {summary.totalProjects}
              </Typography>

            </CardContent>
          </Card>
        </Grid>

      </Grid>

      {/* ========================================= */}
      {/* CHARTS */}
      {/* ========================================= */}

      <Grid container spacing={3}>

        {/* MONTHLY REVENUE CHART */}

        <Grid item xs={12} md={8}>

          <Card>

            <CardContent>

              {/* ⭐ CHANGED TITLE */}
              <Typography mb={2}>
                Revenue Trend (Last 6 Months)
              </Typography>

              <ResponsiveContainer width="100%" height={300}>

                {/* ⭐ CHANGED: BarChart → LineChart */}
                <LineChart data={monthlyRevenue}>

                  {/* ⭐ ADDED GRID FOR BETTER VISUAL */}
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="month" />

                  <YAxis />

                  <Tooltip />

                  {/* ⭐ LINE GRAPH */}
                  <Line
                    type="monotone"
                    dataKey="revenue"
                    stroke="#6366F1"
                    strokeWidth={3}
                    dot={{ r: 5 }}
                  />

                </LineChart>

              </ResponsiveContainer>

            </CardContent>

          </Card>

        </Grid>

        {/* CLIENT BILLING PIE */}

        <Grid item xs={12} md={4}>

          <Card>

            <CardContent>

              <Typography mb={2}>
                Revenue by Client
              </Typography>

              <ResponsiveContainer width="100%" height={300}>

                <PieChart>

                  <Pie
                    data={clientBilling}
                    dataKey="amount"
                    nameKey="client"
                    outerRadius={100}
                    label
                  >

                    {clientBilling.map((entry, index) => (

                      <Cell
                        key={index}
                        fill={COLORS[index % COLORS.length]}
                      />

                    ))}

                  </Pie>

                  <Legend />

                  <Tooltip />

                </PieChart>

              </ResponsiveContainer>

            </CardContent>

          </Card>

        </Grid>

      </Grid>

    </Box>

  );
}